import React, { useState, useEffect } from 'react';

const ProgressBar = ({
  isProgressHidden,
  progress,
  formName,
  nowStep,
  changeStep,
}) => {
  const [open, setOpen] = useState(1);
  useEffect(() => setOpen((state) => (state < nowStep ? nowStep : state)), [
    nowStep,
  ]);

  return (
    <div
      className={`container pt-${isProgressHidden ? '2' : '6'}`}
      style={{ visibility: isProgressHidden ? 'hidden' : '' }}>
      <div className='row justify-content-center'>
        <div className='col-lg-6'>
          <div className='progress-wrapper'>
            <div className='progress-info'>
              <div className='progress-label'>
                <span>Form completed</span>
              </div>
              <div className='progress-percentage'>
                <span>{progress}%</span>
              </div>
            </div>
            <div className='progress'>
              <div
                className='progress-bar bg-primary'
                role='progressbar'
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col d-flex flex-row justify-content-center'>
          {formName.map((name, i) => (
            <div key={i} className='mx-4'>
              <div
                className={`icon icon-shape icon-sm ${
                  nowStep === i + 1
                    ? 'bg-success'
                    : i + 1 <= open
                    ? 'bg-primary'
                    : 'bg-default'
                } rounded-circle text-white mr-2`}
                style={{ cursor: `${i + 1 <= open ? 'pointer' : ''}` }}
                onClick={() => (i + 1 <= open ? changeStep(i + 1) : {})}
                >
                <span>{i + 1}</span>
              </div>
              {name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
